import { useRef, useEffect, useState } from 'react';

export const useAudioStreaming = ({
  currentTime,
  isRecording,
  isPaused,
  chunkStartAfter = 30,
  chunkInterval = 30
}) => {
  const transcriptionAreaRef = useRef(null);
  const [lastChunkSecond, setLastChunkSecond] = useState(-1);

  // Använd currentTime från useRecording för chunk-export
  useEffect(() => {
    if (isRecording && !isPaused && currentTime >= chunkStartAfter) {
      if (
        (currentTime - chunkStartAfter) % chunkInterval === 0 &&
        currentTime !== lastChunkSecond
      ) {
        setLastChunkSecond(currentTime);
        if (transcriptionAreaRef.current) {
          transcriptionAreaRef.current.exportChunk().catch((err) => {
            console.error('Error exporting chunk:', err);
          });
        }
      }
    }
  }, [currentTime, isRecording, isPaused, chunkStartAfter, chunkInterval, lastChunkSecond]);

  const startRecording = () => {
    if (transcriptionAreaRef.current) {
      transcriptionAreaRef.current.startRecording();
    }
  };

  const stopRecording = async () => {
    if (transcriptionAreaRef.current) {
      return await transcriptionAreaRef.current.stopRecording();
    }
    return null;
  };

  return {
    transcriptionAreaRef,
    startRecording,
    stopRecording
  };
};